export const SITE_PAGES = [
  {
    id: "accueil",
    label: "Accueil",
    texts: [
      { key: "hero_sub", label: "Sous-titre du hero" },
      { key: "about.eyebrow", label: "Présentation — surtitre" },
      { key: "about.title", label: "Présentation — titre" },
      { key: "about.p1", label: "Présentation — paragraphe 1" },
      { key: "about.p2", label: "Présentation — paragraphe 2" },
      { key: "about.p3", label: "Présentation — paragraphe 3" },
      { key: "owners.eyebrow", label: "Propriétaires — surtitre" },
      { key: "owners.title", label: "Propriétaires — titre" },
      { key: "owners.text", label: "Propriétaires — texte" },
      { key: "owners.cta", label: "Propriétaires — bouton" },
      { key: "travelers.eyebrow", label: "Voyageurs — surtitre" },
      { key: "travelers.title", label: "Voyageurs — titre" },
      { key: "travelers.text", label: "Voyageurs — texte" },
      { key: "travelers.cta", label: "Voyageurs — bouton" },
      { key: "services.eyebrow", label: "Services — surtitre" },
      { key: "services.title", label: "Services — titre" },
      { key: "services.sub", label: "Services — introduction" },
      { key: "gallery.quote", label: "Citation au-dessus des locations" },
      { key: "providers.eyebrow", label: "Prestataires — surtitre" },
      { key: "providers.title", label: "Prestataires — titre" },
      { key: "providers.sub", label: "Prestataires — introduction" },
    ],
    images: [
      { key: "hero", label: "Image principale (hero)" },
      { key: "hillTown", label: "Bloc Propriétaires" },
      { key: "boatSail", label: "Bloc Voyageurs" },
    ],
  },
  {
    id: "services",
    label: "Services",
    texts: [
      { key: "services.items.gardiennage.title", label: "Gardiennage — titre" },
      { key: "services.items.gardiennage.desc", label: "Gardiennage — description" },
      { key: "services.items.gardiennage.info", label: "Gardiennage — info" },
      { key: "services.items.linge.title", label: "Linge — titre" },
      { key: "services.items.linge.desc", label: "Linge — description" },
      { key: "services.items.linge.info", label: "Linge — info" },
      { key: "services.items.bateau.title", label: "Bateau — titre" },
      { key: "services.items.bateau.desc", label: "Bateau — description" },
      { key: "services.items.bateau.info", label: "Bateau — info" },
      { key: "services.items.courses.title", label: "Courses — titre" },
      { key: "services.items.courses.desc", label: "Courses — description" },
      { key: "services.items.courses.info", label: "Courses — info" },
      { key: "services.avis.title", label: "Avis — titre" },
    ],
    images: [
      { key: "coastRugged", label: "Image d'en-tête" },
      { key: "door", label: "Gardiennage" },
      { key: "linen", label: "Linge de maison" },
      { key: "boat", label: "Location de bateau" },
      { key: "groceries", label: "Courses & livraison" },
    ],
  },
  {
    id: "prestataires",
    label: "Prestataires",
    texts: [
      { key: "providers.items.coach.title", label: "Coach — titre" },
      { key: "providers.items.coach.desc", label: "Coach — description" },
      { key: "providers.items.masseuse.title", label: "Masseuse — titre" },
      { key: "providers.items.masseuse.desc", label: "Masseuse — description" },
      { key: "providers.items.coiffeur.title", label: "Coiffeur — titre" },
      { key: "providers.items.coiffeur.desc", label: "Coiffeur — description" },
      { key: "providers.items.chauffeur.title", label: "Chauffeur — titre" },
      { key: "providers.items.chauffeur.desc", label: "Chauffeur — description" },
      { key: "providers.items.cuisinier.title", label: "Chef / Traiteur — titre" },
      { key: "providers.items.cuisinier.desc", label: "Chef / Traiteur — description" },
      { key: "providers.items.babysitter.title", label: "Babysitter — titre" },
      { key: "providers.items.babysitter.desc", label: "Babysitter — description" },
      { key: "providers.cta_title", label: "Appel à l'action — titre" },
      { key: "providers.cta_text", label: "Appel à l'action — texte" },
      { key: "providers.cta_button", label: "Appel à l'action — bouton" },
    ],
    images: [
      { key: "redRocks", label: "Image d'en-tête" },
      { key: "coach", label: "Coach sportif" },
      { key: "spa", label: "Masseuse" },
      { key: "coiffeur", label: "Coiffeur" },
      { key: "chauffeur", label: "Chauffeur" },
      { key: "chefPlating", label: "Chef / Traiteur" },
      { key: "babysitter", label: "Babysitter" },
    ],
  },
  {
    id: "locations",
    label: "Locations",
    texts: [
      { key: "locations_page.eyebrow", label: "Surtitre" },
      { key: "locations_page.title", label: "Titre" },
      { key: "locations_page.sub", label: "Introduction" },
    ],
    images: [{ key: "coastAerial", label: "Image d'en-tête" }],
  },
  {
    id: "contact",
    label: "Contact",
    texts: [
      { key: "contact.eyebrow", label: "Surtitre" },
      { key: "contact.title", label: "Titre" },
      { key: "contact.sub", label: "Sous-titre" },
      { key: "contact.intro_owners", label: "Intro — paragraphe propriétaires" },
      { key: "contact.intro_travelers", label: "Intro — paragraphe voyageurs" },
      { key: "contact.feed_slogan", label: "Titre des annonces suggérées" },
    ],
    images: [{ key: "mountainSea", label: "Image d'en-tête" }],
  },
  {
    id: "pied_de_page",
    label: "Pied de page",
    texts: [
      { key: "footer.navigation", label: "Titre Navigation" },
      { key: "footer.reserve", label: "Bouton Réserver" },
      { key: "footer.legal", label: "Mentions légales" },
      { key: "footer.privacy", label: "Politique de confidentialité" },
      { key: "footer.created_by", label: "Créé par l'agence" },
      { key: "footer.rights", label: "Tous droits réservés" },
    ],
    images: [
      { key: "logoWhite", label: "Logo blanc (sur fond foncé)" },
      { key: "logoBlack", label: "Logo foncé (sur fond clair)" },
    ],
  },
];
